import { Component } from '@angular/core';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-lost-and-found-wrapper',
  template: `
    <app-lost-and-found-v2 *ngIf="useRebranded"></app-lost-and-found-v2>
    <app-lost-and-found *ngIf="!useRebranded"></app-lost-and-found>
  `
})
export class LostAndFoundWrapperComponent {
  public useRebranded: boolean;

  constructor(private featureFlagService: FeatureFlagsService) {
    this.useRebranded = this.featureFlagService.isEnabled('useRebrandedLayout');
  }
}
